import { useTranslation } from "react-i18next";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import ServicePageLayout from "./components/ServicePageLayout";
import { instalacionMantenimientoData } from "@/mocks/services";

export default function InstalacionPage() {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <SEO
        title="Instalación y Mantenimiento HVAC | Ventra Core León"
        description="Servicios integrales de instalación, mantenimiento preventivo y correctivo de sistemas HVAC, eléctricos y de energía UPS en León, Guanajuato. Técnicos certificados."
        keywords="instalación HVAC, mantenimiento preventivo, mantenimiento correctivo, pólizas de servicio, técnicos certificados, refacciones originales, León Guanajuato"
        canonical="https://ventracore.com.mx/instalacion-y-mantenimiento"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "@id": "https://ventracore.com.mx/instalacion-y-mantenimiento#service",
            "serviceType": "Instalación y Mantenimiento HVAC",
            "provider": { "@id": "https://ventracore.com.mx/#organization" },
            "areaServed": {
              "@type": "City",
              "name": "León",
            },
            "description": "Instalación, mantenimiento preventivo y correctivo de sistemas HVAC en León, Guanajuato.",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Servicios",
                "item": "https://ventracore.com.mx/servicios",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Instalación y Mantenimiento",
                "item": "https://ventracore.com.mx/instalacion-y-mantenimiento",
              },
            ],
          },
        ]}
      />
      <ServicePageLayout
        title={t("servicesPage.installationTitle")}
        subtitle={t("servicesPage.installationSubtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-center mb-10 md:mb-14">
            {instalacionMantenimientoData.intro}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {instalacionMantenimientoData.features.map((f) => (
              <div
                key={f.title}
                className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                  <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                    <i className={f.icon} />
                  </span>
                </div>
                <h4 className="text-base font-bold text-magenta mb-2">
                  {f.title}
                </h4>
                <p className="text-sm text-text-muted leading-relaxed">
                  {f.description}
                </p>
              </div>
            ))}
          </div>

          <p className="text-sm text-text-muted text-center mt-10 md:mt-14">
            {instalacionMantenimientoData.contact}
          </p>
        </div>
      </ServicePageLayout>
    </Layout>
  );
}